import {
  HOUSE_ABOUT_STEP,
  HOUSE_BASIC_INFO_STEP,
  HOUSE_FIND_STEP,
  HOUSE_PRICE_STEP,
} from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/House/houseSteps";

import { FormStates } from "Store/priceCalculation/priceCalculationInterfaces";

export function mapHouseToForm(
  existingState: Record<string, any>,
  localStorageData?: Record<string, any>,
): FormStates {
  if (!localStorageData) {
    return {};
  }
  const formStates: FormStates = {};
  Object.entries(localStorageData).forEach(([key, value]) => {
    switch (key) {
      case HOUSE_FIND_STEP.id:
        formStates[HOUSE_FIND_STEP.id] = {
          addressSameAsHomeAddress: value.addressSameAsHomeAddress,
          recentlyBought: value.recentlyBought,
          postNumber: value.postNumber,
          city: value.city,
          address: value.address,
          cadastralGnr: value.cadastralGnr,
          cadastralBnr: value.cadastralBnr,
          realEstateInfo: value.realEstateInfo,
        };
        return;
      case HOUSE_BASIC_INFO_STEP.id:
        formStates[HOUSE_BASIC_INFO_STEP.id] = {
          houseType: value.houseType,
          constructionYear: value.constructionYear,
          boa: value.boa,
          bta: value.bta,
          saved: value.saved,
          otherBuildings: value.otherBuildings,
        };
        return;
      case HOUSE_ABOUT_STEP.id:
        formStates[HOUSE_ABOUT_STEP.id] = {
          historicalValue: value.historicalValue,
          hasBasementRoom: value.hasBasementRoom,
          rentalOrUnoccupied: value.rentalOrUnoccupied,
          validNumberOfRentalUnits: value.validNumberOfRentalUnits,
          validNumberOfInhabitants: value.validNumberOfInhabitants,
          isRoofChanged: value.isRoofChanged,
          isWetAreasRehabilitatedOrChanged:
            value.isWetAreasRehabilitatedOrChanged,
          isWithHistoryOfWaterOrMoistureDamage:
            value.isWithHistoryOfWaterOrMoistureDamage,
          pestsDamaged: value.pestsDamaged,
          injuries: value.injuries,
          injuryYear: value.injuryYear,
          maintenanceConfirmation: value.maintenanceConfirmation,
          hasFireAlarm: value.hasFireAlarm,
          hasBurglarAlarm: value.hasBurglarAlarm,
          hasWaterGuard: value.hasWaterGuard,
          hasCircuitBreakers: value.hasCircuitBreakers,
          hasPipeInPipeSystem: value.hasPipeInPipeSystem,
        };
        return;
      case HOUSE_PRICE_STEP.id:
        const { coverage } = value;
        if (coverage) {
          formStates[HOUSE_PRICE_STEP.id] = {
            deductible: value.deductible,
            coverage,
            buyHouseContentsInsurance: value.buyHouseContentsInsurance,
          };
        }
        return;
      default:
        return;
    }
  });
  return formStates;
}
